# Usage:
#   Place an `<amount-modal></amount-modal>` object on the page that has the modal(s).
# To activate modal, either:
#   1. PREFERRED: Use `<amount-modal-anchor>Anchor text goes here!</amount-modal-anchor>`
#      with the following attributes to open a modal:
#       * template-id: String; the name of the template in `modals.yml`
#       * modal-config: String (valid JSON object stringified)
#     Ex:
#       <amount-modal-anchor
#         template-id="my_template"
#         modal-config='{"specialVariable": "Some value {{ canContainAngularInterpolations }}"}'
#       >
#         This text will be what the user clicks on to open the modal!
#       </amount-modal-anchor>
#     N.B.: if you're passing a non-interpolated variable (say a function) in,
#           you'll need to wrap the config hash in parentheses inside the quotes.
#            E.g.:
#             <amount-modal-anchor ... modal-config='({"myFunc": theFn })'>
#           This is due to a limitation of `eval` that must be used if variables
#           need to be passed in.
#   2. Call `openAmountModal(templateId, modalConfig)` from `ApplicationCtrl` scope
#   3. Broadcast "amountModal:open", passing the following args:
#       * templateId: String
#       * modalConfig: Object or String (valid JSON object stringified)

angular.module("avant.customer_applications.directives").directive "amountModal", [
  "$rootScope", "$window", "ApplicationService", "ConfigService"
  ($rootScope, $window, ApplicationService, ConfigService) ->
    restrict: 'E'
    scope: false
    template: '''
      <div class="modal__overlay" ng-class="{ 'modal__overlay--show': isOpen, 'modal__overflow': scrollableModal }">
        <div
          class="modal__fpo" aria-labelledby="{{ ariaLabelledby }}"
          ng-include src="currentModalTemplate"
          amount-scroll-to-bottom="scrollableModal"
          amount-trap-focus role="dialog" aria-modal="true"
        />
      </div>
    '''
    link: (scope, element, attrs) ->
      scope.useAmountModal = true # This is used to determine whether to use the new directive or old bootstrap/remodal modals
      scope.isOpen = false

      scope.close = () ->
        scope.isOpen = false

        # Re-enable main page from scrolling after modal is closed
        $rootScope.scrollLock = false

        scope.modal_message = null
        scope.currentModalTemplate = null
        scope.modalConfig = {}
        scope.scrollableModal = null

        scope.elementInvokingModal?.focus()

      scope.$on('amountModal:open', (ev, templateId, config = {}) ->
        scope.$emit "amountTrapFocus:reset"
        if typeof config is 'string'
          try
            config = JSON.parse config
          catch err
            config = eval config

        scope.modalConfig = config
        scope.isOpen = true
        scope.ariaLabelledby = config["aria-labelledby"]

        if scope.hasTealiumEventData(templateId) then scope.tealiumView(templateId)

        # Prevent main page from scrolling while modal is open
        $rootScope.scrollLock = true

        scope.currentModalTemplate = "#{templateId}.html"
        scope.scrollableModal = config.scrollableModal || false
      )

      scope.$on "amountModal:close", scope.close
      scope.$on "amountTrapFocus:close", scope.close

      scope.setModalDownloadLink = (downloadPath, fileName) ->
        scope[downloadPath] = """
          #{ConfigService.apiPrefix}/#{ApplicationService.target_application_id()}/#{downloadPath}
        """
        if fileName
          scope[downloadPath] += "?file_name=#{fileName}"
  ]

angular.module("avant.customer_applications.directives").directive "amountModalAnchor", ['$rootScope', ($rootScope) ->
  restrict: 'E'
  transclude: true
  scope:
    templateId: '@'
    modalConfig: '@'
  template: '<a href="javascript:void(0);" ng-click="open();" ng-transclude></a>'
  link: (scope) ->
    scope.open = () ->
      $rootScope.$broadcast "amountModal:open", scope.templateId, scope.modalConfig
]

angular.module("avant.customer_applications.directives").directive "amountModalCloseIcon", () ->
  restrict: 'E'
  template: '''
    <div class=modal__close>
      <button
        aria-label="modal close button"
        ng-click="close()"
      >
        <amount-icon
          icon-name="#icon-close"
          aria-hidden="true"
        ></amount-icon>
      </button>
    </div>
  '''

angular.module("avant.customer_applications.directives").directive "amountScrollToBottom", ->
  restrict: 'A'
  link: (scope, element) ->

    raw = element[0]

    element.bind "scroll", =>
      if (raw.scrollTop + raw.offsetHeight) * 1.025 >= raw.scrollHeight
        document.getElementById("consent_button").disabled = false
